import React, { useState } from 'react';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import {
    BookOpen,
    Clock,
    Users,
    MoreHorizontal,
    Filter,
    Plus,
    Calendar
} from 'lucide-react';

export default function MyClasses() {
    const [selectedStandard, setSelectedStandard] = useState('Standard - 10');
    const [selectedDivision, setSelectedDivision] = useState('Division - A');

    const classesData = [
        { id: 1, sn: '01', title: "Mathematics", grade: "Grade 10A", time: "09:00 - 10:00 AM", students: "32 Students", status: 'Active' },
        { id: 2, sn: '02', title: "Physics", grade: "Grade 12B", time: "11:30 - 12:30 PM", students: "28 Students", status: 'Active' },
        { id: 3, sn: '03', title: "Advanced Algebra", grade: "Grade 11C", time: "01:00 - 02:00 PM", students: "30 Students", status: 'Upcoming' }
    ];

    return (
        <div className="flex h-screen bg-[#F8FAFC] overflow-hidden font-sans">
            <Sidebar />

            <main className="flex-1 overflow-y-auto px-8">
                <Header
                    title="Assigned Classes"
                    subtitle="Overview of your academic schedule for March 2026"
                    showStandardSelector={true}
                    showDivisionSelector={true}
                    selectedStandard={selectedStandard}
                    selectedDivision={selectedDivision}
                    setSelectedStandard={setSelectedStandard}
                    setSelectedDivision={setSelectedDivision}
                >
                    <div className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm transition-all hover:bg-gray-50 cursor-pointer">
                        <Calendar size={18} className="text-gray-400" />
                        <span>Academic Year 2025-26</span>
                    </div>

                    {/* <button className="flex items-center gap-2 px-4 py-2.5 bg-white border border-gray-100 rounded-xl text-[14px] font-bold text-gray-700 shadow-sm hover:bg-gray-50">
                        <Filter size={18} className="text-gray-400" />
                        Filter
                    </button> */}
                </Header>

                {/* Main Content Table Card */}
                <div className="bg-white rounded-[32px] border border-gray-100 shadow-sm overflow-hidden flex flex-col mb-10">
                    <div className="p-8 flex items-center justify-between border-b border-gray-50">
                        <div className="flex items-center gap-6">
                            <h3 className="text-[20px] font-black text-[#111827]">My teaching sections</h3>
                            <div className="flex items-center gap-2">
                                <span className="w-2.5 h-2.5 bg-blue-500 rounded-full"></span>
                                <span className="text-gray-400 font-bold text-[14px]">03 Active Classes</span>
                            </div>
                        </div>
                        <button className="p-1.5 text-gray-400 hover:text-gray-900 transition-colors">
                            <MoreHorizontal size={22} />
                        </button>
                    </div>

                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-[#F8FAFC]">
                                <tr>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-center">S/N</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Class Subject</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Timing</th>
                                    <th className="px-6 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Enrolled</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase">Status</th>
                                    <th className="px-8 py-5 text-[12px] font-black text-gray-400 tracking-widest uppercase text-right">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {classesData.map((v, i) => (
                                    <tr key={i} className="border-b border-gray-50 last:border-0 hover:bg-slate-50 transition-all group">
                                        <td className="px-8 py-5 text-[14px] font-bold text-gray-500 text-center">{v.sn}</td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-4">
                                                <div className="w-11 h-11 rounded-xl bg-blue-50 text-blue-500 flex items-center justify-center group-hover:bg-blue-500 group-hover:text-white transition-all duration-300">
                                                    <BookOpen size={20} strokeWidth={2.5} />
                                                </div>
                                                <div>
                                                    <p className="text-[15px] font-black text-[#111827] group-hover:text-blue-500 transition-colors">{v.title}</p>
                                                    <p className="text-[12px] font-bold text-gray-400 uppercase tracking-wider">{v.grade}</p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2.5 text-[14px] font-bold text-gray-700">
                                                <Clock size={16} className="text-gray-400" />
                                                {v.time}
                                            </div>
                                        </td>
                                        <td className="px-6 py-5">
                                            <div className="flex items-center gap-2.5 text-[14px] font-bold text-gray-700">
                                                <Users size={16} className="text-gray-400" />
                                                {v.students}
                                            </div>
                                        </td>
                                        <td className="px-8 py-5">
                                            <span className={`text-[11px] font-black px-3 py-1.5 rounded-lg inline-block text-center uppercase tracking-widest ${v.status === 'Active' ? 'text-emerald-500 bg-emerald-50/50' :
                                                'text-amber-500 bg-amber-50/50'
                                                }`}>
                                                {v.status}
                                            </span>
                                        </td>
                                        <td className="px-8 py-5 text-right">
                                            <div className="flex items-center justify-end gap-2">
                                                <button className="px-4 py-2 bg-slate-50 text-slate-500 rounded-lg text-[12px] font-black hover:bg-blue-50 hover:text-blue-600 transition-all">
                                                    View Details
                                                </button>
                                                <button className="p-2 text-gray-400 hover:text-gray-900 transition-colors">
                                                    <MoreHorizontal size={18} />
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="p-8 border-t border-gray-50 flex items-center justify-between">
                        <div className="flex items-center gap-2 text-[14px] font-bold text-gray-400">
                            Total 3 classes assigned for the week
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
